import { Component, OnInit } from '@angular/core';

import { ActionCableService } from '../../../services/common/action-cable.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-angular-test',
  templateUrl: './angular-test.component.html',
  styleUrls: ['./angular-test.component.css'],
})
export class AngularTestComponent implements OnInit {
  channelName: string = 'TestChannel';

  channelIdentifier: string = 'subscription_1';

  channelSubscription: any;

  channelStatus: string = 'Not connected';

  documentId: number;

  documentPages: string;

  errorText: string = 'Test error';

  message: string;

  outgoingJobId: number = 86870;

  constructor(private actionCableService: ActionCableService, private notyService: NotyService) {}

  ngOnInit() {}

  connectToTestChannel() {
    let scope: AngularTestComponent = this;
    this.actionCableService.cable().then((cable) => {
      if (this.channelSubscription) {
        this.channelSubscription.unsubscribe();
        this.channelSubscription = null;
      }
      this.channelSubscription = cable.subscriptions.create(
        {
          channel: this.channelName,
          identifier: this.channelIdentifier,
        },
        {
          received: (data: any) => {
            console.log('Received', data);
            scope.notyService.notify('Received', 'success');
          },
        }
      );
      this.channelStatus = 'Connected';
    });
  }

  sendMessage() {
    if (this.channelSubscription) {
      this.channelSubscription.send({ message: this.message });
      this.notyService.notify(`Sent message: ${this.message}`, 'info');
    } else this.notyService.notify('No channel subscribed', 'error');
  }

  triggerError() {
    throw this.errorText || 'Test error';
  }
}
